module.exports = __webpack_public_path__ + "static/media/corncatcher.49523f44.jpg";